import { makeStyles, withStyles } from '@material-ui/styles'
import { Badge, colors } from '@material-ui/core'

export const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: -1,
      left: -1,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge)

export const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.appBar,
    // Efeito Glassmorphism Baseado nos Tokens Globais da Paleta
    backgroundColor: theme.palette.topbarBackground,
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)', // Suporte Safari/iOS
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    color: theme.palette.topbarContrastText,
  },
  flexGrow: {
    flexGrow: 1,
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit',
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900],
    },
  },
  trialIcon: {
    marginRight: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: theme.palette.secondary.main,
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  logoText: {
    marginLeft: theme.spacing(1),
  },
  infoUser: {
    color: theme.palette.topbarContrastText,
    fontWeight: 500,
    marginRight: theme.spacing(1),
  },
  sigepTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    letterSpacing: '0.5px',
    marginRight: theme.spacing(2),
    color: theme.palette.topbarContrastText,
    cursor: 'default',
    userSelect: 'none',
  },
  sigepLogo: {
    height: '18px',
    width: 'auto',
    marginRight: theme.spacing(2),
    // Como a Topbar agora é sempre escura em ambos os modos, a logo (que possui texto original preto) é sempre invertida para branco.
    filter: 'invert(1) brightness(2)',
    transition: 'filter 0.3s ease',
    cursor: 'pointer',
  },
  searchContainer: {
    flex: 1,
    maxWidth: 400,
    marginLeft: theme.spacing(2),
  },
  userInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(3),
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)', // Feedback de clique claro (fundo Topbar escuro)
    },
  },
  userAvatar: {
    width: 36,
    height: 36,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontWeight: 600,
    fontSize: '1rem',
  },
  iconActions: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  cestaIcon: {
    width: 22,
    height: 22,
    display: 'block',
    // O ícone da cesta é branco/claro por padrão e a Topbar é sempre escura
    filter: 'none',
    transition: 'transform 0.2s ease-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  cestaBadge: {
    height: 18,
    minWidth: 18,
    width: 18,
    borderRadius: '50%',
    fontSize: '9px',
    fontWeight: 700,
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1.5px solid ${theme.palette.topbarBackground}`,
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.palette.type === 'dark' ? '0 1px 3px rgba(10, 37, 64, 0.15)' : '0 1px 3px rgba(0, 0, 0, 0.2)',
    // Reposiciona o badge para baixo e para o centro, afastando do topo superior do TopBar
    top: '8px !important',
    right: '8px !important',
  },
  classBadge: {
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}))

export default useStyles
